import { useMemo } from 'react';

import Axios from 'axios';
import logger from 'loglevel';

const settings = {
  initialized: false,
  remote: {
    url: null,
  },
};

const sendErrorToServer = (payload) => {
  try {
    Axios.post(settings.remote.url, payload).catch((err) => {
      // if post to endpoint fails, probably will fail again!?
      console.error(err);
    });
  } catch (e) {
    logger.error(e);
  }
};

/**
 * @param {any} logData
 * @param {string} level
 */
const logByLevel = (logData, level) => {
  logger[level](logData);

  if (settings.remote && settings.remote.url) {
    const payload = {
      timestamp: Date.now(),
      message: logData.message,
      stacktrace: logData.stack,
      level,
      meta: logData.meta,
    };

    sendErrorToServer(payload);
  }
};

export const useLogger = () => {
  return useMemo(() => {
    return {
      /**
       * Init the logger by setting a level and options for sending the log to remote server
       * @param {'trace' | 'debug' | 'info' | 'warn' | 'error' | 'silent'} level
       * @param {Object} remoteOptions
       */
      init(level, remoteOptions) {
        if (settings.initialized) return;

        logger.setLevel(level);

        if (remoteOptions) {
          settings.remote = {
            ...settings.remote,
            ...remoteOptions,
          };
        }

        settings.initialized = true;
      },
      /**
       * Log with level=trace
       * @param {any} data
       */
      trace(data) {
        logByLevel(data, 'trace');
      },
      /**
       * Log with level=log which is an alias for debug
       * @param {any} data
       */
      log(data) {
        logByLevel(data, 'log');
      },
      /**
       * Log with level=info
       * @param {any} data
       */
      info(data) {
        logByLevel(data, 'info');
      },
      /**
       * Log with level=warn
       * @param {any} data
       */
      warn(data) {
        logByLevel(data, 'warn');
      },
      /**
       * Log with level=error
       * @param {any} data
       */
      error(data) {
        logByLevel(data, 'error');
      },
    };
  }, []);
};
